// @ vendors
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');
const { RA_PROJECTION_CHART_ALL_PRODUCTS } = require('constants/RAConstants');
// @ utilities
const { setNoOfChartPointsWithoutObjective } = require('utilities/RAObjectiveTrackingGetYearAndNoOfPoints');
const { chunk } = require('utilities/helperFunctions');

function _addRangesToChartData(data) {
    data.forEach(d => {
        d.lowRange = [d.one, d.mid];
        d.highRange = [d.mid, d.ninetyNine];
    });

    return data;
}

function handleChartSuccess(state, data, dataPoints, product) {
    if (product === RA_PROJECTION_CHART_ALL_PRODUCTS) {
        const productsChartData = chunk(data, dataPoints);

        productsChartData.forEach(d => {
            _addRangesToChartData(d);
        });

        const newData = { isFetching: false };

        if (dataPoints === 2) {
            newData.barChartData = productsChartData;
        } else {
            newData.productsChartData = productsChartData;
        }

        return state.merge(newData);
    }

    return state.merge({ chartData: _addRangesToChartData(data), isFetching: false });
}

const initialState = Immutable.fromJS({
    barChartData: {},
    chartButtons: [2, 10, 25],
    chartData: [],
    chartYears: 10,
    currentChartData: [],
    error: null,
    errorCurrent: null,
    isFetching: false,
    isFetchingCurrent: false,
    noOfChartPoints: 66,
    productsChartData: {
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
    },
});

const RAExpectedProfitability = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_EXPECTED_PROFITABILITY_CHANGE_YEARS:
            const chartYears = action.payload.years;
            const noOfChartPoints = setNoOfChartPointsWithoutObjective(chartYears);

            return state.merge({
                chartYears,
                noOfChartPoints,
            });
        case actionTypes.RA_EXPECTED_PROFITABILITY_CHART_REQUEST:
            return state.merge({ isFetching: true, error: null, chartData: [] });
        case actionTypes.RA_EXPECTED_PROFITABILITY_CHART_SUCCESS:
            const { data, dataPoints, product } = action.payload;

            return handleChartSuccess(state, data, dataPoints, product);
        case actionTypes.RA_EXPECTED_PROFITABILITY_CHART_FAILURE:
            return state.merge({ isFetching: false, error: action.payload.data });
        default:
            return state;
    }
};

module.exports = RAExpectedProfitability;
